export default __webpack_public_path__ + "static/media/gemtiers.fe1da367.png";